import { render, staticRenderFns } from "./ReadStatus.vue?vue&type=template&id=caef0496&scoped=true"
import script from "./ReadStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadStatus.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReadStatus.vue?vue&type=style&index=0&id=caef0496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caef0496",
  null
  
)

export default component.exports